(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lalya-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-lalya-hero-cycle]').forEach((cycle) => {
      const slides = Array.from(cycle.querySelectorAll('[data-lalya-hero-slide]'));
      if (slides.length < 2) return;

      let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;

      window.setInterval(() => {
        slides[activeIndex].classList.remove('is-active');
        activeIndex = (activeIndex + 1) % slides.length;
        slides[activeIndex].classList.add('is-active');
      }, 2000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lalya-first-drop-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initDropCycles = (root = document) => {
      root.querySelectorAll('[data-lalya-drop-cycle]').forEach((cycle) => {
        if (cycle.dataset.lalyaCycleReady === 'true') return;

        const slides = Array.from(cycle.querySelectorAll('[data-lalya-drop-slide]'));
        if (slides.length < 2) return;

        cycle.dataset.lalyaCycleReady = 'true';

        let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (activeIndex < 0) {
          activeIndex = 0;
          slides[activeIndex].classList.add('is-active');
        }

        if (reducedMotion) return;

        window.setInterval(() => {
          if (document.hidden) return;
          slides[activeIndex].classList.remove('is-active');
          activeIndex = (activeIndex + 1) % slides.length;
          slides[activeIndex].classList.add('is-active');
        }, 2000);
      });
    };

    initDropCycles();
    document.addEventListener('shopify:section:load', (event) => initDropCycles(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lalya-product-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-lalya-marquee-cycle]').forEach((cycle, cycleIndex) => {
      const slides = Array.from(cycle.querySelectorAll('[data-lalya-marquee-slide]'));
      if (slides.length < 2) return;

      let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;

      const delay = 2000 + (cycleIndex % 4) * 180;

      window.setInterval(() => {
        slides[activeIndex].classList.remove('is-active');
        activeIndex = (activeIndex + 1) % slides.length;
        slides[activeIndex].classList.add('is-active');
      }, delay);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lalya-visual-shop-path"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-lalya-panel-cycle]').forEach((cycle) => {
      const slides = Array.from(cycle.querySelectorAll('[data-lalya-panel-slide]'));
      if (slides.length < 2) return;

      let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;

      window.setInterval(() => {
        slides[activeIndex].classList.remove('is-active');
        activeIndex = (activeIndex + 1) % slides.length;
        slides[activeIndex].classList.add('is-active');
      }, 3000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
